import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var _excluded = ["ref", "className", "to", "target", "children", "isInternal"],
    _excluded2 = ["className", "to", "target", "renderLink", "children"];
var LinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};

var defaultRenderLink = function defaultRenderLink(_ref) {
  var ref = _ref.ref,
      className = _ref.className,
      to = _ref.to,
      target = _ref.target,
      children = _ref.children,
      isInternal = _ref.isInternal,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref,
    href: to,
    target: target,
    className: classnames(className)
  }, props), children);
};

var Link = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      to = _ref2.to,
      target = _ref2.target,
      renderLink = _ref2.renderLink,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var isInternal = /^(\/|#)(?!\/)/.test(to);
  return renderLink(_extends({
    ref: ref,
    to: to,
    target: target,
    className: className,
    isInternal: isInternal,
    children: children
  }, props));
});
Link.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  target: PropTypes.oneOf(Object.keys(LinkTarget)),
  renderLink: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Link.defaultProps = {
  className: undefined,
  target: LinkTarget.self,
  renderLink: defaultRenderLink
};
var modules_79b43374 = {
  "btn": "Button_module_btn__4440de1a",
  "btn--disabled": "Button_module_btn_Disabled__4440de1a",
  "btn--icon-left": "Button_module_btn_IconLeft__4440de1a",
  "btn--no-label": "Button_module_btn_NoLabel__4440de1a",
  "btn--icon": "Button_module_btn_Icon__4440de1a",
  "btn--icon-right": "Button_module_btn_IconRight__4440de1a",
  "btn--full": "Button_module_btn_Full__4440de1a"
};
var _excluded$1 = ["type", "className", "classNames", "defaultStyle", "noStyle", "label", "to", "target", "onClick", "icon", "iconPlacement", "disabled", "full", "LinkComponent", "linkComponentProps", "children"],
    _excluded2$1 = ["className"];
var ButtonType = {
  button: "button",
  submit: "submit",
  reset: "reset"
};
var ButtonLinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};
var ButtonIconPlacement = {
  left: "left",
  right: "right"
};
var defaultClassNames = {
  iconWrapper: modules_79b43374["btn--icon"]
};

var Button = function Button(_ref) {
  var _cx;

  var type = _ref.type,
      className = _ref.className,
      providedClassNames = _ref.classNames,
      defaultStyle = _ref.defaultStyle,
      noStyle = _ref.noStyle,
      label = _ref.label,
      to = _ref.to,
      target = _ref.target,
      onClick = _ref.onClick,
      icon = _ref.icon,
      iconPlacement = _ref.iconPlacement,
      disabled = _ref.disabled,
      full = _ref.full,
      LinkComponent = _ref.LinkComponent,
      providedLinkComponentProps = _ref.linkComponentProps,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var classNames = _extends({}, defaultClassNames, providedClassNames);

  var _providedLinkComponen = providedLinkComponentProps.className,
      providedLinkComponentClassName = _providedLinkComponen === void 0 ? "" : _providedLinkComponen,
      restLinkComponentProps = _objectWithoutPropertiesLoose(providedLinkComponentProps, _excluded2$1);

  var linkComponentProps = _extends({
    to: to,
    target: target
  }, restLinkComponentProps);

  var noStyleClasses = classnames(className, providedLinkComponentClassName);
  var classes = classnames((_cx = {}, _cx[modules_79b43374.btn] = defaultStyle, _cx[modules_79b43374["btn--disabled"]] = disabled && modules_79b43374["btn--disabled"], _cx[modules_79b43374["btn--no-label"]] = !label && !children && modules_79b43374["btn--no-label"], _cx[modules_79b43374["btn--icon-" + iconPlacement]] = icon && iconPlacement && modules_79b43374["btn--icon-" + iconPlacement], _cx[modules_79b43374["btn--full"]] = full && modules_79b43374["btn--full"], _cx[noStyleClasses] = noStyleClasses, _cx)); // Check for empty onClick handlers

  if (to && typeof onClick !== "function") {
    return /*#__PURE__*/React.createElement(LinkComponent, _extends({
      className: classnames(noStyle ? noStyleClasses : classes)
    }, linkComponentProps), icon && iconPlacement === "left" && /*#__PURE__*/React.createElement("span", {
      className: classnames(classNames.iconWrapper)
    }, icon), children || label, icon && iconPlacement === "right" && /*#__PURE__*/React.createElement("span", {
      className: classnames(classNames.iconWrapper)
    }, icon));
  }

  return /*#__PURE__*/React.createElement("button", _extends({
    className: classnames(noStyle ? noStyleClasses : classes) // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    "aria-label": label || children,
    disabled: disabled,
    onClick: onClick
  }, props), icon && iconPlacement === "left" && /*#__PURE__*/React.createElement("span", {
    className: classnames(classNames.iconWrapper)
  }, icon), children || label, icon && iconPlacement === "right" && /*#__PURE__*/React.createElement("span", {
    className: classnames(classNames.iconWrapper)
  }, icon));
};

Button.defaultProps = {
  className: undefined,
  classNames: defaultClassNames,
  type: ButtonType.button,
  label: undefined,
  to: undefined,
  target: ButtonLinkTarget._self,
  onClick: undefined,
  icon: undefined,
  iconPlacement: ButtonIconPlacement.left,
  disabled: false,
  full: false,
  noStyle: false,
  defaultStyle: true,
  LinkComponent: Link,
  linkComponentProps: {},
  children: undefined
};
export default Button;
export { Button, ButtonIconPlacement, ButtonLinkTarget, ButtonType };